export default "__VITE_ASSET__CCUG_r7u__"